import { Box, Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from 'yup';
import EasyForm, { FormType } from "../../components/Forms/EasyForm";
import EasyFormColumn from "../../components/Forms/EasyFormColumn";
import { TextFieldRender } from "../../components/Forms/Renders/TextFieldRender";

import { AddModerator } from "@mui/icons-material";
import { OrganisationBadge } from "../../components/Badges/OrganisationBadge";
import { CreateEntityButton } from "../../components/CreateEntityButton";
import { AutocompleteFieldRender } from "../../components/Forms/Renders/AutocompleteFieldRender";
import { TextRenderer } from "../../components/Forms/Renders/TextRenderer";
import { OrganisationContext } from "../../components/Layout/OrganisationPicker";
import { Role, ServiceAccountPOST, getRolesUpTo, roleToString } from "../../models/User";
import { useAddServiceAccountMutation } from "./redux/userApiSlice";
import { UserInfoDialog } from "./userDetailsButton/UserInfoDialog";


export const CreateServiceAccountButton = () => {
    const { t } = useTranslation()
    const [open, setOpen] = useState<boolean>(false)

    return (
        <CreateEntityButton tooltip={t('Create service account')} open={open} setOpen={setOpen} buttonIcon={<AddModerator />}>
            <DrawerContent />
        </CreateEntityButton>
    )
}
export const DrawerContent = () => {
    const [submittedUser, setSubmittedUser] = useState<ServiceAccountPOST | undefined>(undefined)
    return (
        <>
            {submittedUser == undefined ?
                <CreateServiceAccountButtonContent afterSaveAction={(user) => setSubmittedUser(user)} /> :
                <UserInfoDialog userUuid={submittedUser.uuid} />
            }
        </>
    )
}

export interface CreateServiceAccountButtonContentProps {
    afterSaveAction: (user?: ServiceAccountPOST) => void
}
export const CreateServiceAccountButtonContent = (props: CreateServiceAccountButtonContentProps) => {
    const { t } = useTranslation();
    const SignupSchema = Yup.object().shape({
        keycloak_uuid: Yup.string().uuid().required(t("Required")),
        name: Yup.string().required(t("Required")),
        email: Yup.string().email(t("Email is invalid")).required(t("Required")),
        role: Yup.string().required(t("Required")),
    });

    const organisationContext = useContext(OrganisationContext);
    const organisation = organisationContext?.organisation
    return (
        <>

            <Box>
                <Grid container justifyContent="center">

                    <Grid item xs={6}>
                        <Typography variant="h6">{t("Create service account") + ""}</Typography>
                    </Grid>
                </Grid>
                <Grid container justifyContent="center">
                    <Grid item xs={6}>

                        <EasyForm
                            isAllowedToEdit={() => true}
                            editModeAlways={true}
                            arrayPath=""
                            SignupSchema={SignupSchema}
                            createNew={() => {
                                const postBody = new ServiceAccountPOST();
                                postBody.organisation = organisation;
                                return postBody;
                            }}
                            columns={[
                                new EasyFormColumn("", "", [
                                    new TextRenderer({
                                        displayText: "Organisation",
                                        fieldName: "organisation",
                                        uniqueId: "no_id",
                                        render: () => <OrganisationBadge ressource={organisation} />
                                    }),
                                    new TextFieldRender({
                                        displayText: "Name",
                                        fieldName: "name",
                                        uniqueId: "no_id",
                                        type: "text"
                                    }),
                                    new TextFieldRender({
                                        displayText: "Email",
                                        fieldName: "email",
                                        uniqueId: "no_id",
                                        type: "email"
                                    }),
                                    new AutocompleteFieldRender({
                                        displayText: "Role",
                                        fieldName: "role",
                                        getOptionLabelFunc: (option: Role) => roleToString(option) ?? "",
                                        options: getRolesUpTo(Role.ORG_ADMIN),
                                        uniqueId: "no_id"
                                    }),
                                    new TextFieldRender({
                                        displayText: "Keycloak UUID",
                                        fieldName: "keycloak_uuid",
                                        uniqueId: "no_id",
                                        type: "text"
                                    })
                                ])
                            ]}
                            formType={FormType.INFORMATION}
                            idToFetch={"no_id"}
                            getFieldRows={() => []}
                            saveMutation={useAddServiceAccountMutation}
                            afterSaveAction={props.afterSaveAction}
                        />
                    </Grid>
                </Grid>

            </Box>
        </>
    )
}